<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="
            content-area__heading
            pr-4
            border-0
            md:border-r
            border-solid border-grey-light
          "
        >
          <h2 class="mb-1">ระบบวิเคราะห์ข้อมูลการรับ-จ่ายน้ำมัน</h2>
        </div>
        <!-- <p class="mx-5 mt-2">ข้อมูลการรับ-จ่ายน้ำมันของเรือบรรทุกน้ำมัน</p> -->
      </div>
    </div>
    <vx-card>
      <vs-row vs-w="12" class="my-5">
        <vs-col
          vs-type="flex"
          class="mb-1"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="h7 px-1 w-1/3 text-right">วันที่เริ่ม:</div>
          <v-date-picker
            v-model="selectedDate"
            mode="date"
            is-range
            is24hr 
            :locale="$i18n.locale"
            :buddhist="true"
            :max-date="new Date()"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <vs-button
                v-on="inputEvents.start"
                size="small"
                color="#cccccc"
                type="border"
                class="w-full text-left"
              >
                <div class="vx-row">
                  <vs-icon size="small" icon="today" color="dark"></vs-icon>
                  <h6 class="mt-1 mx-2">
                    {{setDateFormatTh(selectedDate.start)}} -
                    {{setDateFormatTh(selectedDate.end)}}
                  </h6>
                  <p hidden>{{inputValue}}</p>
                </div>
              </vs-button>
            </template>
          </v-date-picker>
        </vs-col>
       <vs-col
          vs-type="flex"
          class="mb-1"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="h7 px-1 w-1/3 text-right">เรือบรรทุกน้ำมัน :</div>
          <v-select
            placeholder="กรุณาเลือกเรือบรรทุกน้ำมัน"
            class="w-2/3"
            v-model="selectedForwardTanker"
            :options="optionsTanker"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          /><br />
        </vs-col>
        <vs-col
          vs-type="flex justify-center"
          class="mb-1"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
        <div class="ml-8">
          <vs-button
            class="py-2 px-5 "
            color="#0066cc"
            type="border"
            icon-pack="feather"
            icon="icon-search"
            @click="getOilTransfers()"
            >ค้นหา</vs-button
          >
        </div>
        </vs-col>
      </vs-row>
      <!-- <hr class="my-10" /> -->
    </vx-card>

    <vx-card class="mt-5 z-0">
      <vs-row v-if="isActiveRefinary">
        <vs-col vs-type="flex"
          vs-justify="center"
          vs-lg="7"
          vs-sm="7"
          vs-xs="12"
          class="static"
        >
          <CardOilValue 
            class="absolute top-0 ml-2 mr-5"
            :totalOilVolume="totalOilVolume"
          />
          <DirectTree :config="config" :station="selectedStation" :transferDataForDirectTree="oilTransfers"  :isActive="isActiveRefinary"/>
        </vs-col>
         <vs-col vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="5"
          vs-sm="5"
          vs-xs="12"
        >
          <Map :config="config" :transfers="transfers"/>
        </vs-col>
      </vs-row>
    </vx-card>
    <vx-card class="mt-5 z-0">
      <div class="px-5 pb-5 relative">
        <div class="flex justify-between">
          <div class="flex">
            <h5 class="my-5">ตารางการจัดส่งน้ำมัน</h5>
            <p class="pr-4 border-0 md:border-r border-solid border-grey-light mr-5"></p>
            <div class="mt-5">
              <vs-chip color="#BADDC2">
                <p style="color: #000">ยอดรับ {{ receive ? formatNumber(receive): 0 }} ลิตร</p>
              </vs-chip>
              <vs-chip color="#F7CAC8">
                <p style="color: #000">ยอดจ่าย {{ prorate ? formatNumber(prorate): 0 }} ลิตร</p>
              </vs-chip>
            </div>
          </div>
          <div>
            <vs-button
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-printer"
              @click="print()"
            >
              พิมพ์
            </vs-button>
          </div>
        </div>
        <vs-table
          maxHeight="460px"
          class="static text-center mt-3"
          :max-items="descriptionItems[0]"
          description
          :description-items="descriptionItems"
          description-title="ลำดับ"
          description-connector="จาก"
          description-body="จำนวนต่อหน้า"
          pagination
          :data="oilTransfers"
        >
          <!-- <template slot="header">
            <div class="px-5 pb-5 flex">
              
            </div>
          </template> -->
          <template slot="thead">
            <vs-th><p class="mx-auto text-center"> ลำดับ </p></vs-th>
            <vs-th sort-key="start_at"><p class="mx-auto text-center"> วันที่เริ่ม </p></vs-th>
            <vs-th><p class="mx-auto text-center"> โรงกลั่น </p></vs-th>
            <vs-th><p class="mx-auto text-center"> ชื่อเรือบรรทุกน้ำมัน </p></vs-th>
            <vs-th><p class="mx-auto text-center"> เรือสถานีบริการน้ำมัน </p></vs-th>
            <vs-th><p class="mx-auto text-center"> ความจุถังน้ำมันเรือสถานีบริการน้ำมัน </p></vs-th>
            <vs-th><p class="mx-auto text-center"> เรือประมง </p></vs-th>
            <vs-th><p class="text-center"> ความจุถังน้ำมันเรือประมง </p></vs-th>
            <vs-th><p class="mx-auto text-center"> ตำแหน่ง(Lat,Lon) </p></vs-th>
            <vs-th sort-key="volume"><p class="mx-auto text-center"> ปริมาณน้ำมัน (ล.) </p></vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.index + 1 }}
              </vs-td>

              <vs-td :data="data[indextr].start_at">
                {{data[indextr].start_at}}
              </vs-td>

              <vs-td :data="data[indextr].station && data[indextr].station.name">
                <a
                  href="#"
                  @click="activeRefinary(data[indextr].station)"
                  >
                  {{ data[indextr].station && data[indextr].station.name }}
                  <!-- {{ data[indextr].station }} -->
                  </a
                >
              </vs-td>

              <vs-td :data="data[indextr].forwardTanker && data[indextr].forwardTanker.name">
                {{ data[indextr].forwardTanker && data[indextr].forwardTanker.name }}
              </vs-td>

              <vs-td :data="data[indextr].tanker && data[indextr].tanker.name">
                {{ data[indextr].tanker && data[indextr].tanker.name }}
              </vs-td>

              <vs-td :data="data[indextr].tanker && data[indextr].tanker.capacity">
                {{ data[indextr].tanker && getVolume(data[indextr].tanker.capacity) }}
              </vs-td>

              <vs-td :data="data[indextr].vessel && data[indextr].vessel.name">
                {{ data[indextr].vessel && data[indextr].vessel.name }}
              </vs-td>

              <vs-td :data="data[indextr].vessel && data[indextr].vessel.capacity">
                {{ data[indextr].vessel && getVolume(data[indextr].vessel.capacity) }}
              </vs-td>

              <vs-td :data="data[indextr]">
                <a href="#" @click="isActiveNotification(data[indextr])">{{ data[indextr].latitude }} , {{ data[indextr].longitude }}</a>
              </vs-td>

              <vs-td :data="data[indextr].volume" v-if="data[indextr].station && !data[indextr].tanker ">
                  {{ getVolume(data[indextr].volume) }}
              </vs-td>
              <vs-td :data="data[indextr].volume" v-else-if="data[indextr].forwardTanker && data[indextr].tanker ">
                <p :style="checkCapacityAndVolume(data[indextr].tanker.capacity,data[indextr].volume) ? 'color: red' : 'color: green'">
                  {{ getVolume(data[indextr].volume) }}
                </p>
              </vs-td>
              <vs-td :data="data[indextr].volume" v-else-if="data[indextr].tanker && data[indextr].vessel ">
                <p :style="checkCapacityAndVolume(data[indextr].vessel.capacity,data[indextr].volume) ? 'color: red' : 'color: green'">
                  {{ getVolume(data[indextr].volume) }}
                </p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Swal from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import _ from "lodash";
import vSelect from "vue-select";
import { formatNumber } from "@/utils/index";
import downloadExcel from "vue-json-excel";
import DirectTree from "@/components/charts/DirectedTreeOilTransfer.vue";
import Map from "@/components/map/Map.vue";
import CardOilValue from "@/components/statistics-cards/CardOilValue.vue";

export default {
  name: "RefineryOilTransferDashboard",
  components: {
    vSelect,
    Datepicker,
    downloadExcel,
    DirectTree,
    Map,
    CardOilValue
  },
  data() {
    return {
      formatNumber,
      config: {
        startDate: moment().format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY"),
        station: "",
        forwardTanker: "",
        tanker: "",
        vessel: ""
      },
      destinationType: "transit",
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },

      optionsRefinery: [],
      optionsDestinationType: [],
      optionsTanker: [],
      optionsVessel: [],

      selectedRefinery: "",
      selectedForwardTanker: "",
      selectedTanker: "",
      selectedVessel: "",

      descriptionItems: [10, 25, 50, 100],
      jsonFieldsTransit: {
        ลำดับ: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        วันที่เริ่ม: "departed_at_formatted_be",
        ชื่อโรงกลั่น: "station.code",
        MMSI: "vessel.mmsi",
        ชื่อเรือบรรทุกน้ำมัน: "vessel.name",
        "ปริมาณน้ำมัน (ลิตร)": "volumes",
      },
      jsonFieldsDomisticExport: {
        ลำดับ: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        วันที่เริ่ม: "departed_at_formatted_be",
        ชื่อโรงกลั่น: "station.code",
        ชื่อเรือบรรทุกน้ำมัน: "vessel.name",
        ประเภทน้ำมัน: "oil_type",
        "ปริมาณน้ำมัน (ลิตร)": "volume",
        "ปริมาณน้ำมันรวม (ลิตร)": {
          field: "volumes",
          callback: (value) => {
            return `${this.getVolume(value)}`;
          },
        },
      },

      oilTransfers: [],
      isActiveRefinary: false,
      selectedStation: null,
      totalOilVolume: 0,
      isCheckCapacityAndVolume: null,
      receive: 0,
      prorate: 0
      
    };
  },
  computed: {
    ...mapState({
      transfers: (state) => state.oilTransfer.oilTransfers,
    }),
  },
  async mounted() {
    await this.$store.dispatch("rts/setPositionEventNotification", null);
    this.getRefinaries()
    this.getTankers()
    this.getVessels()
  },
  watch: {
    async transfers(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        await this.setData(newVal)
        await this.getOilVolume()
      }
    },
    oilTransfers(newVal, oldVal){
      for (let i = 0; i < newVal.length; i++) {
        this.oilTransfers[i].index = i;
      }
    }
  },
  methods: {
    async getOilTransfers() {
      this.isActiveRefinary = false;
      
      if (this.selectedForwardTanker) {
      this.config =  {
        startDate: this.setDateFormat(this.selectedDate.start),
        endDate: this.setDateFormat(this.selectedDate.end),
        station: this.selectedRefinery && this.selectedRefinery.id,
        forwardTanker: this.selectedForwardTanker && this.selectedForwardTanker.id,
        tanker: this.selectedTanker && this.selectedTanker.id,
        vessel: this.selectedVessel && this.selectedVessel.id
      },
      // console.log("this.config ===> ", this.config);
      localStorage.setItem('searchOilTransfer', JSON.stringify(this.config));
      await this.$store.dispatch("oilTransfer/getOilTransfers", this.config);
      } else {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกเรือบรรทุกน้ำมัน",
          text: "สำหรับการค้นหาข้อมูลการรับ-จ่ายน้ำมันของเรือบรรทุกน้ำมัน",
          showConfirmButton: false,
          timer: 2000,
        })
      }
      console.log("this.oilTransfers ", this.oilTransfers);
    },
    async getRefinaries(){
      await this.$store.dispatch("mpTankerData/getMpStations");
      const stations = this.$store.state.mpTankerData.mpStations
      _.map(stations, (station) => {
        this.optionsRefinery.push({ id: station.id, label: station.name_en })
      })
    },
    async getTankers(){
      await this.$store.dispatch("mpTankerData/getMpTankerAll");
      const tankers = this.$store.state.mpTankerData.mpTankerAll
      _.map(tankers, (tanker) => {
        this.optionsTanker.push({ id: tanker.id, label: tanker.name, mmsi: tanker.mmsi })
      })
    },
    async getVessels(){
      await this.$store.dispatch("mpTankerData/getMpVesselAll");
      const vessels = this.$store.state.mpTankerData.mpVesselAll
      console.log("vessels >>> ", vessels.length);
      _.map(vessels, (vessel) => {
        this.optionsVessel.push({ id: vessel.id, label: vessel.name, registerNumber: vessel.register_number })
      })
    },
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setDateFormatTh(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date).add(543, "years").format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    getVolume(data) {
      return formatNumber(Number(data));
    },
    async activeRefinary(refinary) {
      this.selectedStation = refinary
      this.selectedStation.type = "station"

      this.config.station = refinary.id
      this.config.forwardTanker = null
      this.config.tanker = null

      await this.$store.dispatch("oilTransfer/getOilTransfers", this.config);
      // console.log("this.transfers>>>> ", this.transfers);
      // await this.setData(this.transfers)
      this.isActiveRefinary = true;
    },
    async setData(data){
      this.$vs.loading()
      this.oilTransfers = [];
      for (const a of data) {
        a.station_id && await this.$store.dispatch("mpTankerData/getMpStationById",a.station_id)
        a.forward_tanker_id && await this.$store.dispatch("mpTankerData/getMpForWardTankerById",a.forward_tanker_id)
        a.tanker_id && await this.$store.dispatch("mpTankerData/getMpTankerById",a.tanker_id)
        a.vessel_id && await this.$store.dispatch("mpTankerData/getMpVesselById",a.vessel_id)

        const station = this.$store.state.mpTankerData.mpStation
        const forwardTanker = this.$store.state.mpTankerData.mpForWardTanker
        const tanker = this.$store.state.mpTankerData.mpTanker
        const vessel = this.$store.state.mpTankerData.mpVessel

        const dataTransfer = {
          ...a,
          station: a.station_id && station,
          forwardTanker: a.forward_tanker_id && forwardTanker,
          tanker: a.tanker_id && tanker,
          vessel: a.vessel_id && vessel,
        };

        this.oilTransfers.push(dataTransfer)
      }
      // console.log("this.oilTransfer >>>>> ", this.oilTransfers);
      this.$vs.loading.close()
    },
    getOilVolume(){
      if (this.config.forwardTanker) {
        this.totalOilVolume = _.sumBy(this.oilTransfers, (o)=>{
          if (o.tanker) { return o.volume }
        })
      }else if (this.config.tanker) {
        this.totalOilVolume = _.sumBy(this.oilTransfers, (o)=>{
          if (o.vessel) { return o.volume }
        })
      } else {
        this.totalOilVolume = _.sumBy(this.oilTransfers, 'volume')
      }

      if(this.totalOilVolume == undefined ){
        this.totalOilVolume = _.sumBy(this.oilTransfers, 'volume')
      }

      this.receive = _.sumBy(this.oilTransfers, (o)=>{
        if (o.station) { return o.volume }
        else { return 0 }
      })
      this.prorate = _.sumBy(this.oilTransfers, (o)=>{
        if (o.tanker) { return o.volume }
        else { return 0 }
      })
      console.log("receive :: ", this.receive, this.prorate);

    },
    checkCapacityAndVolume(capacity,volume){
      return Number(volume) >= Number(capacity) ? true : false
    },
    print(){
      window.open(`/admin/oil_transfer/print`, '_blank')
    },
    async isActiveNotification(data) {
      this.$vs.loading();
      data.to_s = data.tanker ? `<p>${data.forwardTanker.name} <br/> 
        MMSI: ${data.forwardTanker.mmsi}<br/>
        <b style="color: red">จ่ายน้ำมัน</b>ให้ ${data.tanker.name}<br/>
        ความจุถัง: ${this.getVolume(data.tanker.capacity)} <br/>
        ปริมาณ ${this.getVolume(data.volume)} ลิตร <br/> วันที่ ${data.start_at}</p>`
        : `<p>${data.forwardTanker.name} <br/> 
        MMSI: ${data.forwardTanker.mmsi}<br/>
        ความจุถัง: ${this.getVolume(data.forwardTanker.capacity)} <br/>
        <b style="color: green">รับน้ำมัน</b>จาก ${data.station.name} (${data.station.name_en})<br/>
        ปริมาณ ${this.getVolume(data.volume)} ลิตร <br/> วันที่ ${data.start_at}</p>`
      // console.log("isActiveNotification >> ", data.to_s);

      this.$router.push(`/monitoring`);
      await this.$store.dispatch("rts/setPositionEventNotification", data);
      this.$vs.loading.close();
      // this.$router.push(`/monitoring`);
    },
  },
};
</script>

<style lang="css" scoped></style>
